import React, { useState } from "react";
import StatusBar from "../StatusBar/StatusBar";
import "./TheGramApp.css";
import "../MessageApp/Messages.css";
import GramPost from "./GramPost";
import Messages from "../MessageApp/Messages";
import { Chat_content } from "../MessageApp/MessagesInterfaces";
import { GramPostProps } from "./TheGramAppInterfaces";
import GramLogo from "./MMC_Phone App_TheGram.svg";
import GramHomeButton from "./MMC_Phone App_TheGram_Home.svg";
import GramDmButton from "./MMC_Phone App_TheGram_DM.svg";

interface TheGramAppProps {
  content: GramPostProps[];
  messages?: Chat_content[];
  notifications: number;
  handleStateChange?: (chat: Chat_content) => void;
}

const TheGramApp: React.FC<TheGramAppProps> = ({
  content,
  messages,
  notifications,
  handleStateChange,
}) => {
  const [showMessages, setShowMessages] = useState(false);

  const handleMessageClick = () => {
    setShowMessages(true);
  };

  const handleHomeClick = () => {
    setShowMessages(false);
  };

  return (
    <>
      {!showMessages ? (
        <div className={`thegram-app`}>
          <div className="thegram-app-status-bar">
            <StatusBar />
          </div>
          <div className="thegram-app-header">
            <div className="thegram-home-button">
              <button
                onClick={() => handleHomeClick()}
                style={{ background: "none", border: "none" }}
              >
                <img
                  src={GramHomeButton}
                  alt="Direct Message"
                  className="dm-button"
                  style={{ width: "4.5vh", height: "4.5vh" }}
                />
              </button>
            </div>
            <div className="thegram-app-title">
              <img
                src={GramLogo}
                alt="TheGram Logo"
                className="thegram-logo"
                style={{ height: "4.5vh" }}
              />
            </div>
            <div className="message-button">
              <button
                onClick={() => (messages ? handleMessageClick() : null)}
                className="dm-button"
                style={{ background: "none", border: "none" }}
              >
                <img
                  src={GramDmButton}
                  alt="Direct Message"
                  style={{ width: "4.5vh", height: "4.5vh" }}
                />
              </button>
              {notifications > 0 && (
                <div
                  className="notification-dot"
                  style={{
                    position: "relative",
                    top: "-6.5vh", // Added top
                    right: "-2.5vw", // Changed from right to left
                    borderRadius: "50%",
                    backgroundColor: "red",
                    color: "white",
                    padding: "0.2vh",
                    fontSize: "1.3vh",
                    width: "1.5vh", // Added width
                    height: "1.5vh", // Added height
                    textAlign: "center",
                  }}
                >
                  {notifications}
                </div>
              )}
            </div>
          </div>

          <div className="posts-list">
            {content.map((post, index) => (
              <GramPost key={index} post={post} />
            ))}
            <div style={{ minHeight: "10vh", background: "lightgrey" }}>
              ...
            </div>
          </div>
        </div>
      ) : (
        messages && (
          <div style={{ background: "lightgrey", height: "100%" }}>
            <Messages
              influencerMessageContent={messages}
              theGram={true}
              handleStateChange={handleStateChange}
              handleHomeClick={() => setShowMessages(false)}
            />
          </div>
        )
      )}
    </>
  );
};

export default TheGramApp;
